(() => {
  const root = document.querySelector('[data-pcs-filter]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const cfg = root.dataset;
  const form = root.querySelector('[data-pcs-filter-form]');
  const container = root.querySelector('[data-pcs-container]');
  const facetsRoot = root.querySelector('[data-pcs-filter-facets]');
  const grid = root.querySelector('[data-pcs-filter-grid]');
  const countEl = root.querySelector('[data-pcs-filter-count]');
  const status = root.querySelector('[data-pcs-filter-status]');
  const pagination = root.querySelector('[data-pcs-filter-pagination]');
  const appliedBox = root.querySelector('[data-pcs-applied]');
  const appliedItems = root.querySelector('[data-pcs-applied-items]');
  const activeCount = root.querySelector('[data-pcs-active-count]');
  const sortLabel = root.querySelector('[data-pcs-sort-label]');
  const icon = (name) => (root.querySelector(`template[data-pcs-icon="${name}"]`) || {}).innerHTML || '';

  const facetDefinitions = [
    ['vendor', 'Marke', false],
    ['product_type', 'Produkttyp', false],
    ['gender', 'Geschlecht', false],
    ['size', 'Größe', true],
    ['color', 'Farbe', false],
    ['condition', 'Zustand', false]
  ];
  const filterKeys = facetDefinitions.map(([key]) => key);
  const pageSize = 48;
  const money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  const sortNames = { collection: 'Neueste zuerst', newest: 'Neueste zuerst', price_asc: 'Preis aufsteigend', price_desc: 'Preis absteigend' };

  let params = new URLSearchParams(window.location.search);
  let currentPage = Math.max(1, Number(params.get('page')) || 1);
  let currentFacets = {};
  let requestNumber = 0;
  let booted = false;
  let facetUid = 0;

  const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const bool = (value) => value === 'true';
  const fmt = (cents) => `${money.format(cents / 100)} `;

  /* ---------- Karten im Aufbau des Theme-Snippets product-block ---------- */
  function imageTag(item, eager) {
    if (!item.image) return '<div class="placeholder-image"></div>';
    let src = item.image;
    let srcset = '';
    try {
      const base = new URL(item.image);
      const make = (w) => { base.searchParams.set('width', String(w)); return base.toString(); };
      src = make(740);
      srcset = [340, 480, 740, 980, 1200].map((w) => `${make(w)} ${w}w`).join(', ');
    } catch (error) { /* Originalbild verwenden */ }
    const perRow = Number(cfg.perRow) || 4;
    const sizes = `(min-width: 1600px) ${Math.round(1600 / perRow)}px, (min-width: 768px) ${Math.round(100 / perRow)}vw, 50vw`;
    return `<img src="${esc(src)}" alt="${esc(item.image_alt || item.title)}"${srcset ? ` srcset="${esc(srcset)}"` : ''} sizes="${sizes}" loading="${eager ? 'eager' : 'lazy'}"${eager ? ' fetchpriority="high"' : ''} decoding="async" class="theme-img">`;
  }

  /* Zweites Bild (Rückseite) erscheint beim Hover am PC. */
  function hoverImageHtml(item) {
    if (!item.image2 || item.image2 === item.image) return '';
    let src = item.image2;
    let srcset = '';
    try {
      const base = new URL(item.image2);
      const make = (w) => { base.searchParams.set('width', String(w)); return base.toString(); };
      src = make(740);
      srcset = [340, 480, 740, 980, 1200].map((w) => `${make(w)} ${w}w`).join(', ');
    } catch (error) { /* Originalbild verwenden */ }
    const perRow = Number(cfg.perRow) || 4;
    const sizes = `(min-width: 1600px) ${Math.round(1600 / perRow)}px, (min-width: 768px) ${Math.round(100 / perRow)}vw, 50vw`;
    return `<div class="product-block__image product-block__image--secondary product-block__image--show-on-hover"><div class="img-ar img-ar--cover" style="--aspect-ratio: ${esc(cfg.aspect)}">` +
      `<img alt="" data-pcs-src="${esc(src)}"${srcset ? ` data-pcs-srcset="${esc(srcset)}"` : ''} sizes="${sizes}" decoding="async" class="theme-img"></div></div>`;
  }
  /* Rückseiten im Hintergrund vorladen (nur am PC mit Maus): erst wenn das Vorderbild einer Karte geladen ist und sie in die Nähe des Sichtbereichs kommt,
     und höchstens 3 gleichzeitig mit niedriger Priorität, damit Vorderbilder und Scrollen nie ausgebremst werden. */
  const connection = navigator.connection || {};
  const preloadBack = window.matchMedia('(hover: hover) and (pointer: fine)').matches && !connection.saveData && !/(^|-)(2g|3g)$/.test(connection.effectiveType || '');
  function loadHover(block) {
    const img = block.querySelector('img[data-pcs-src]');
    if (!img) return;
    if (img.dataset.pcsSrcset) img.srcset = img.dataset.pcsSrcset;
    img.src = img.dataset.pcsSrc;
    img.removeAttribute('data-pcs-src');
    img.removeAttribute('data-pcs-srcset');
  }
  const backQueue = [];
  let backActive = 0;
  let backObserver = null;
  function pumpBack() {
    while (backActive < 3 && backQueue.length) {
      const block = backQueue.shift();
      const img = block.querySelector('img[data-pcs-src]');
      if (!img) continue;
      backActive++;
      const done = () => { backActive--; pumpBack(); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
      img.fetchPriority = 'low';
      loadHover(block);
    }
  }
  function queueBack(block) {
    const front = block.querySelector('.product-block__image--primary img');
    const go = () => { backQueue.push(block); pumpBack(); };
    if (!front || front.complete) go();
    else { front.addEventListener('load', go, { once: true }); front.addEventListener('error', go, { once: true }); }
  }
  function watchBack() {
    if (backObserver) backObserver.disconnect();
    backQueue.length = 0;
    if (!preloadBack || !('IntersectionObserver' in window)) return;
    backObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        backObserver.unobserve(entry.target);
        queueBack(entry.target);
      });
    }, { rootMargin: '600px 0px' });
    grid.querySelectorAll('product-block').forEach((block) => { if (block.querySelector('img[data-pcs-src]')) backObserver.observe(block); });
  }
  // Fährt die Maus schneller als das Vorladen, wird sofort geladen.
  grid.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    const block = event.target.closest && event.target.closest('product-block');
    if (block) loadHover(block);
  }, { passive: true });

  /* Designermarke: gleiche Liste wie snippets/pp-designer.liquid (Produktseite) */
  const designerVendors = new Set("Burberry, Versace, Armani, Loro Piana, Yves Saint Laurent, Christian Dior, Gianfranco Ferre, Gianfranco Ferré, Valentino, Belstaff, Moschino, Missoni, MCM, Pringle of Scotland, Ermenegildo Zegna, Paul Smith, Pal Zileri, Trussardi, Dsquared2, Karl Lagerfeld, Dolce & Gabbana, Gucci, Iceberg, Prada, Moncler, Lanvin, Fay, Jacob Cohen, Balenciaga, Fendi, Givenchy, Louis Vuitton, Miu Miu, Balmain, Kenzo, Jil Sander, Roberto Cavalli, Max Mara, Escada, Philipp Plein, Marcelo Burlon, Raf Simons, Jacquemus, Brioni, Etro, Cartier, Cerruti, Blumarine, Byblos, Krizia, Les Copains, Luisa Spagnoli, Aquascutum, Canada Goose, Dsquared, Stone Island, Michael Kors, Bogner, Joop, Feraud, Hermès, Hermes, Hermès Paris, Chanel, Celine, Céline, Bottega Veneta, Loewe, Saint Laurent, Dior, Dior Homme, Valentino Garavani, Chloé, Chloe, Stella McCartney, Alexander McQueen, Vivienne Westwood, Maison Margiela, Off-White, Palm Angels, Amiri, Rick Owens, Acne Studios, Isabel Marant, Marc Jacobs, Salvatore Ferragamo, Ferragamo, Tod's, Tods, Bally, Hogan, Comme des Garçons, Comme des Garcons, Issey Miyake, Yohji Yamamoto, Junya Watanabe, Undercover, Giorgio Armani, Emporio Armani, Gianni Versace, Versace Jeans Couture, Emilio Pucci, Pucci, Just Cavalli, Love Moschino, Dolce and Gabbana, Brunello Cucinelli, Kiton, Canali, Corneliani, Boglioli, Lardini, Tagliatore, Herno, Aspesi, Peuterey, Parajumpers, Moose Knuckles, Jean Paul Gaultier, Thierry Mugler, Mugler, Claude Montana, Emanuel Ungaro, Ungaro, Nina Ricci, Courrèges, Courreges, Paco Rabanne, Guy Laroche, Ted Lapidus, Louis Féraud, Louis Feraud".split(', ').map((v) => v.toLowerCase()));
  const diamondSvg = '<svg class="pcs-designer__icon" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 3h12l4 6-10 12L2 9z"></path><path d="M11 3 8 9l4 12 4-12-3-6"></path><path d="M2 9h20"></path></svg>';
  function designerHtml(item) {
    const v = String(item.vendor || '').replace(/’/g, "'").trim().toLowerCase();
    return v && designerVendors.has(v) ? `<span class="pcs-designer">${diamondSvg}Designermarke</span>` : '';
  }

  function labelsHtml(item) {
    const labels = [];
    if (bool(cfg.newShow) && cfg.newMethod === 'date' && item.created) {
      const days = (Date.now() / 1000 - item.created) / 86400;
      if (days < Number(cfg.newLimit)) labels.push(`<span class="product-label product-label--new-in"><span>${esc(cfg.newText)}</span></span>`);
    }
    if (labels.length < 2 && bool(cfg.reductionShow) && item.compare_at_cents && item.compare_at_cents > item.price_cents) {
      let text;
      if (cfg.reductionType === 'percent') {
        text = cfg.reductionPercent.replace('__AMOUNT__', String(Math.round((1 - item.price_cents / item.compare_at_cents) * 100)));
      } else {
        text = cfg.reductionValue.replace('__AMOUNT__', money.format((item.compare_at_cents - item.price_cents) / 100));
      }
      labels.push(`<span class="product-label product-label--sale"><span>${esc(text)}</span></span>`);
    }
    return labels.length ? `<div class="product-label-container">${labels.join('')}</div>` : '';
  }

  function priceHtml(item) {
    const onSale = item.compare_at_cents && item.compare_at_cents > item.price_cents;
    const classes = `price${onSale ? ' price--on-sale' : ''}${item.available ? '' : ' price--sold-out'}`;
    let html = `<div class="${classes}"><div class="price__default"><span class="price__current"><span class="visually-hidden js-label">${esc(onSale ? cfg.salePrice : cfg.regularPrice)}</span><span>${fmt(item.price_cents)}</span></span>`;
    if (onSale) {
      html += `<span class="price__was"><span class="visually-hidden js-label">${esc(cfg.regularPrice)}</span><span>${fmt(item.compare_at_cents)}</span></span>`;
    }
    html += '</div>';
    if (bool(cfg.soldOutShow) && !item.available) {
      html += `<span class="price-label price-label--sold-out">${esc(cfg.soldOutText)}</span>`;
    } else if (bool(cfg.saleShow) && onSale) {
      html += `<span class="price-label price-label--sale">${esc(cfg.saleText)}</span>`;
    }
    return `${html}</div>`;
  }

  function cardElement(item, index) {
    const hasSecond = !!(item.image2 && item.image2 !== item.image);
    const block = document.createElement('product-block');
    block.className = 'product-block';
    const eager = index < (Number(cfg.perRow) || 4);
    block.innerHTML =
      '<div class="block-inner"><div class="block-inner-inner">' +
        `<div class="image-cont${hasSecond ? ' image-cont--with-secondary-image image-cont--same-aspect-ratio' : ''}">` +
          `<a class="product-link" href="${esc(item.url)}" aria-hidden="true" tabindex="-1"><div class="image-label-wrap"><div>` +
            `<div class="product-block__image product-block__image--primary product-block__image--active"><div class="img-ar img-ar--cover" style="--aspect-ratio: ${esc(cfg.aspect)}">${imageTag(item, eager)}</div></div>${hoverImageHtml(item)}` +
          `</div>${labelsHtml(item)}${designerHtml(item)}</div></a>` +
        '</div>' +
        `<div class="product-block__detail align-ltr-${esc(cfg.align || 'left')}"><div class="inner"><div class="innerer">` +
          `<a class="product-link" href="${esc(item.url)}"><div class="vendor">${esc(item.vendor || '')}</div><div class="product-block__title">${esc(item.title)}</div>` +
          `<div class="product-price product-price--block">${priceHtml(item)}</div></a>` +
        '</div></div></div>' +
      '</div></div>';
    return block;
  }

  function renderItems(items) {
    grid.replaceChildren(...items.map(cardElement));
    watchBack();
  }

  /* ---------- Filterleiste im Aufbau von snippets/faceted-filters ---------- */
  const selected = (key) => params.getAll(key);

  function renderFacets(facets) {
    currentFacets = facets || {};
    facetsRoot.replaceChildren();
    facetDefinitions.forEach(([key, label, isButtonGrid]) => {
      const entries = currentFacets[key] || [];
      if (!entries.length) return;
      const chosen = selected(key);
      const uid = `pcs-facet-${key}-${++facetUid}`;
      const collapsed = entries.length > 12 && chosen.length === 0;
      const group = document.createElement('div');
      group.className = `filter-group${isButtonGrid ? ' filter-group--button-grid filter-group--layout-three-column' : ' filter-group--layout-two-column'}`;
      group.innerHTML =
        `<toggle-target role="button" tabindex="0" class="filter-group__heading${collapsed ? ' toggle-target-toggler--is-hidden' : ''}" data-toggle-target="#${uid}">` +
          `<div class="filter-group__heading__text">${esc(label)}</div><span class="filter-group__heading__indicator">${icon('chevron-down')}</span></toggle-target>` +
        `<div id="${uid}" class="filter-group__items toggle-target${collapsed ? ' toggle-target--hidden' : ''}${isButtonGrid ? ' pcs-no-scroll' : ''}"><div class="toggle-target-container"></div></div>`;
      const list = group.querySelector('.toggle-target-container');
      if (entries.length > 12 && !isButtonGrid) {
        const search = document.createElement('input');
        search.type = 'search';
        search.className = 'pcs-facet-search';
        search.placeholder = `${label} suchen`;
        search.setAttribute('aria-label', `${label} suchen`);
        search.addEventListener('input', () => {
          const query = search.value.trim().toLocaleLowerCase('de');
          list.querySelectorAll('.filter-group__item').forEach((option) => {
            option.hidden = query !== '' && !option.dataset.search.includes(query);
          });
        });
        list.append(search);
      }
      entries.forEach((entry) => {
        const isActive = chosen.includes(entry.value);
        const option = document.createElement('label');
        option.className = `filter-group__item${isActive ? ' filter-group__item--active' : ''}`;
        option.dataset.search = String(entry.value).toLocaleLowerCase('de');
        option.innerHTML =
          `<input class="filter-group__checkbox" type="checkbox" name="${key}" value="${esc(entry.value)}"${isActive ? ' checked' : ''}>` +
          `<span class="filter-group__item__text">${esc(entry.value)}${isButtonGrid ? '' : '<svg class="filter-tick" role="presentation" viewBox="0 0 20 20"><path d="M8.315 13.859l-3.182-3.417a.506.506 0 0 1 0-.684l.643-.683a.437.437 0 0 1 .642 0l2.22 2.393 4.942-5.327a.436.436 0 0 1 .643 0l.643.684a.504.504 0 0 1 0 .683l-5.91 6.35a.437.437 0 0 1-.642 0"></path></svg>'}</span>` +
          (isButtonGrid ? '' : `<span class="filter-group__item__count">${esc(entry.count)}</span>`);
        option.querySelector('input').addEventListener('change', () => { currentPage = 1; updateFromForm(); });
        list.append(option);
      });
      facetsRoot.append(group);
    });
  }

  function renderApplied() {
    appliedItems.replaceChildren();
    let total = 0;
    filterKeys.forEach((key) => {
      params.getAll(key).forEach((value) => {
        total++;
        const link = document.createElement('a');
        link.className = 'filter-group__applied-item';
        link.href = '#';
        link.innerHTML = `<span class="filter-group__applied-item__text">${esc(value)}</span><span class="filter-group__applied-item__icon">${icon('close')}</span>`;
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const box = [...facetsRoot.querySelectorAll(`input[name="${key}"]`)].find((input) => input.value === value);
          if (box) box.checked = false;
          currentPage = 1;
          updateFromForm();
        });
        appliedItems.append(link);
      });
    });
    ['min_price', 'max_price'].forEach((key) => { if (params.get(key)) total++; });
    if (params.get('min_price') || params.get('max_price')) {
      const link = document.createElement('a');
      link.className = 'filter-group__applied-item';
      link.href = '#';
      const low = params.get('min_price') ? Number(params.get('min_price')) / 100 : 0;
      const high = params.get('max_price') ? money.format(Number(params.get('max_price')) / 100) : '…';
      link.innerHTML = `<span class="filter-group__applied-item__text">${esc(money.format(low))} - ${esc(high)}</span><span class="filter-group__applied-item__icon">${icon('close')}</span>`;
      link.addEventListener('click', (event) => {
        event.preventDefault();
        form.elements.min_price.value = '';
        form.elements.max_price.value = '';
        currentPage = 1;
        updateFromForm();
      });
      appliedItems.append(link);
    }
    appliedBox.hidden = total === 0;
    activeCount.hidden = total === 0;
    activeCount.textContent = total ? `(${total})` : '';
  }

  /* ---------- Zustand, URL und Formular ---------- */
  function readForm() {
    const next = new URLSearchParams(window.location.search);
    [...filterKeys, 'sort', 'min_price', 'max_price', 'available', 'page'].forEach((key) => next.delete(key));
    filterKeys.forEach((key) => {
      // Beim ersten Laden gibt es die Auswahlfelder noch nicht: gewaehlte Filter aus der Adresse uebernehmen.
      if (!booted) params.getAll(key).forEach((value) => next.append(key, value));
      else form.querySelectorAll(`input[name="${key}"]:checked`).forEach((input) => next.append(key, input.value));
    });
    const sort = root.dataset.sort || 'collection';
    if (sort !== 'collection') next.set('sort', sort);
    const toCents = (value) => {
      const number = Number(String(value).replace(',', '.'));
      return Number.isFinite(number) && String(value).trim() !== '' && number >= 0 ? String(Math.round(number * 100)) : '';
    };
    const min = toCents(form.elements.min_price.value);
    const max = toCents(form.elements.max_price.value);
    if (min) next.set('min_price', min);
    if (max) next.set('max_price', max);
    const available = form.querySelector('input[name="available"]:checked');
    if (available && available.value === '1') next.set('available', '1');
    if (currentPage > 1) next.set('page', String(currentPage));
    return next;
  }

  function applyParamsToForm() {
    root.dataset.sort = params.get('sort') && sortNames[params.get('sort')] ? params.get('sort') : 'collection';
    sortLabel.textContent = sortNames[root.dataset.sort];
    ['min_price', 'max_price'].forEach((key) => {
      const value = params.get(key);
      form.elements[key].value = value === null ? '' : String(Number(value) / 100);
    });
    const radio = form.querySelector(`input[name="available"][value="${params.get('available') === '1' ? '1' : ''}"]`);
    if (radio) radio.checked = true;
  }

  function pushUrl(next) {
    const query = next.toString();
    window.history.replaceState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}`);
  }

  /* ---------- Pagination im Aufbau von snippets/pagination-control ---------- */
  function renderPagination(page, pages) {
    pagination.replaceChildren();
    if (pages <= 1) return;
    const numbers = new Set([1, pages]);
    for (let n = page - 2; n <= page + 2; n++) if (n >= 1 && n <= pages) numbers.add(n);
    const sorted = [...numbers].sort((a, b) => a - b);
    let html = '';
    if (page > 1) html += `<a class="pagination__prev pagination__link text-current underline underline--on-hover" href="#" data-page="${page - 1}">&laquo; ${esc(cfg.previous)}</a><span class="pagination__sep">&middot;</span>`;
    let last = 0;
    sorted.forEach((n) => {
      if (n - last > 1) html += '<span class="pagination__number">&hellip;</span>';
      html += `<span class="pagination__number${n === page ? ' underline underline--not-link' : ''}">${n === page ? n : `<a class="pagination__link text-current underline underline--on-hover" href="#" data-page="${n}">${n}</a>`}</span>`;
      last = n;
    });
    if (page < pages) html += `<span class="pagination__sep">&middot;</span><a class="pagination__next pagination__link text-current underline underline--on-hover" href="#" data-page="${page + 1}">${esc(cfg.next)} &raquo;</a>`;
    pagination.innerHTML = html;
  }

  /* ---------- Laden ---------- */
  // Wartet kurz (max. 0,7 s) auf die ersten Bilder, damit die Seite nicht Bild fuer Bild aufpoppt.
  function imagesReady() {
    const waits = [...grid.querySelectorAll('img')].slice(0, 8).map((img) => (img.complete ? Promise.resolve() : new Promise((resolve) => {
      img.addEventListener('load', resolve, { once: true });
      img.addEventListener('error', resolve, { once: true });
    })));
    return Promise.race([Promise.all(waits), new Promise((resolve) => setTimeout(resolve, 700))]);
  }

  async function fetchProducts() {
    const requestId = ++requestNumber;
    grid.classList.add('pcs-loading');
    const next = readForm();
    pushUrl(next);
    params = next;
    const query = new URLSearchParams(next);
    query.set('page', String(currentPage));
    query.set('limit', String(pageSize));
    if (cfg.collection) query.set('collection', cfg.collection);
    const endpoint = new URL(cfg.apiUrl);
    endpoint.search = query.toString();
    status.textContent = '';
    try {
      // Hat die Seite die Anfrage schon frueh gestartet (Inline-Skript), diese Antwort wiederverwenden.
      const early = window.__pcsEarly;
      window.__pcsEarly = null;
      const response = await (early && early.url === endpoint.toString() ? early.promise : fetch(endpoint.toString(), { headers: { Accept: 'application/json' } }));
      if (!response.ok) throw new Error('Filterantwort nicht verfügbar');
      const data = await response.json();
      if (requestId !== requestNumber) return;
      if (!booted) {
        const native = document.querySelector('filter-container');
        const nativeBox = native && native.closest('.container');
        if (nativeBox) nativeBox.hidden = true;
        document.querySelectorAll('.pagination-row:not(.pcs-pagination-row)').forEach((element) => { element.hidden = true; });
        booted = true;
      }
      renderFacets(data.facets);
      renderItems(data.items);
      renderApplied();
      countEl.textContent = cfg.countText.replace('99999', new Intl.NumberFormat('de-DE').format(data.total));
      if (data.total === 0) status.textContent = cfg.empty;
      renderPagination(data.page, data.pages);
      await imagesReady();
      if (requestId === requestNumber) grid.classList.remove('pcs-loading');
    } catch (error) {
      if (requestId !== requestNumber) return;
      grid.classList.remove('pcs-loading');
      if (!booted) {
        // Eigener Filter nicht erreichbar: Platzhalter weg, Shopify-Standardliste wieder zeigen.
        document.documentElement.classList.add('pcs-fallback');
        grid.replaceChildren();
        facetsRoot.replaceChildren();
      }
      status.textContent = booted
        ? 'Die Artikel konnten gerade nicht aktualisiert werden. Bitte versuche es gleich noch einmal.'
        : 'Der eigene Filter ist gerade nicht erreichbar. Die vorhandene Kollektion bleibt sichtbar.';
    }
  }

  function updateFromForm() {
    fetchProducts();
  }

  function goToPage(page) {
    currentPage = Math.max(1, page);
    fetchProducts();
    const anchor = root.querySelector('[data-pcs-utility]');
    if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ---------- Ereignisse ---------- */
  form.addEventListener('submit', (event) => { event.preventDefault(); currentPage = 1; updateFromForm(); });
  form.querySelectorAll('input[name="available"]').forEach((input) => {
    input.addEventListener('change', () => { currentPage = 1; updateFromForm(); });
  });
  root.querySelector('[data-pcs-clear]').addEventListener('click', (event) => {
    event.preventDefault();
    form.reset();
    facetsRoot.querySelectorAll('input[type="checkbox"]').forEach((input) => { input.checked = false; });
    root.dataset.sort = 'collection';
    sortLabel.textContent = sortNames.collection;
    currentPage = 1;
    updateFromForm();
  });
  root.querySelector('[data-pcs-sort-options]').addEventListener('click', (event) => {
    const link = event.target.closest('[data-sort]');
    if (!link) return;
    event.preventDefault();
    root.dataset.sort = link.dataset.sort;
    sortLabel.textContent = sortNames[link.dataset.sort];
    const button = root.querySelector('.link-dropdown__button');
    if (button) button.setAttribute('aria-expanded', 'false');
    const dropdown = root.querySelector('link-dropdown');
    if (dropdown) dropdown.classList.remove('link-dropdown--open', 'open');
    currentPage = 1;
    updateFromForm();
  });
  pagination.addEventListener('click', (event) => {
    const link = event.target.closest('[data-page]');
    if (!link) return;
    event.preventDefault();
    goToPage(Number(link.dataset.page));
  });
  root.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-pcs-toggle-filters]');
    if (!toggle) return;
    event.preventDefault();
    container.classList.toggle('filter-container--show-filters-desktop');
    container.classList.toggle('filter-container--show-filters-mobile');
    const visible = container.classList.contains('filter-container--show-filters-desktop');
    root.querySelectorAll('.toggle-btn[data-pcs-toggle-filters]').forEach((el) => el.classList.toggle('toggle-btn--revealed-desktop', visible));
  });

  applyParamsToForm();
  fetchProducts();
})();
